import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared-service/shared.service';
@Component({
  selector: 'app-reset-password-success-popup',
  standalone: false,
  templateUrl: './reset-password-success-popup.html',
  styleUrls: ['./reset-password-success-popup.scss']
})
export class ResetPasswordSuccessPopup {
  isFirstLogin: boolean = false;

  constructor(
    private readonly dialogRef: MatDialogRef<ResetPasswordSuccessPopup>,
    private readonly router: Router,
    private readonly sharedService: SharedService,
    @Inject(MAT_DIALOG_DATA) public data: boolean
  ) {
    this.isFirstLogin = data;
  }

  goToLogin(): void {
    this.sharedService.setValue('fromResetFlow', 'true');
    this.dialogRef.close(false);
    this.router.navigate(['/login']);
  }

  goToDashboard(): void {
    this.dialogRef.close(false);
    this.router.navigate(['/dashboard']);
  }
}